import './App.css';
import HeadLine from './backend/Hero';
import Navbar from './backend/Navbar';
// import AboutMe from './backend/About';
// import Experience from './backend/Experience';
import Footer from './backend/Footer';
import Skills from './backend/Skills';
import Projects from './backend/Projects';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ContactCard from './backend/Contact';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <div id="home" className="App min-h-screen bg-gradient-to-r from-purple-200 to-violet-100 flex flex-col items-center gap-10">

            <Navbar />
            <HeadLine />
            {/* <AboutMe /> */}
            {/* <Experience />       */}
            <Skills />
            <Projects />
            <ContactCard />
            <Footer />
          </div>
        } />

        <Route path="/projects" element={<Projects />} />
      </Routes>

    </BrowserRouter>
  );
}


export default App;
